import { CresoTextLogo } from "@core/components/logo/creso-logo";
import { BannerImage } from "../login-banner/banner-image";
import { BrandLogo } from "./brand-logo";
import { BrandingPreviewValues } from "./types";

// The login page is laid out at a desktop size and scaled into the preview
const PAGE_WIDTH = 1440;
const PAGE_HEIGHT = 720;

/** Height of the preview when it is rendered at the given width */
export const getWebLoginPreviewHeight = (width: number) =>
  (width * PAGE_HEIGHT) / PAGE_WIDTH;

/** Mirrors the web-clients login page (routes/login.tsx) */
export function WebLoginPreview({
  width,
  brandName,
  tagLine,
  logoUrl,
  distributorName,
  loginBanner,
}: BrandingPreviewValues & { width: number }) {
  const scale = width / PAGE_WIDTH;
  const name = brandName || distributorName;

  return (
    <div
      style={{ width, height: getWebLoginPreviewHeight(width) }}
      className="overflow-hidden rounded-2xl shadow-xl"
    >
      <div
        className="flex origin-top-left bg-white text-stone-900"
        style={{
          width: PAGE_WIDTH,
          height: PAGE_HEIGHT,
          transform: `scale(${scale})`,
        }}
      >
        <div className="relative w-3/5 shrink-0 overflow-hidden">
          {/* The panel is slightly narrower than the 5:4 banner, which the login page crops at the sides */}
          <BannerImage
            banner={loginBanner}
            className="absolute inset-y-0 left-1/2 -translate-x-1/2 aspect-[5/4]"
          />
        </div>

        <div className="flex flex-1 flex-col gap-12 px-16 py-16">
          <div className="flex items-center gap-4">
            <BrandLogo
              url={logoUrl}
              name={name}
              className="size-12 rounded-xl"
            />
            <div className="flex flex-col min-w-0">
              <span className="text-lg font-semibold truncate">{name}</span>
              <span className="text-sm text-stone-500 truncate">
                {tagLine || "AMFI registered Mutual Fund Distributor"}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <span className="text-2xl font-semibold">
              Login to your account
            </span>
            <div className="flex flex-col gap-3">
              <span>Phone number</span>
              <div className="flex items-center gap-4 h-12 px-4 rounded-lg border border-stone-200">
                +91
                <span className="text-stone-500">
                  Enter 10 digit mobile number
                </span>
              </div>
            </div>
            <div className="flex items-center justify-center h-14 rounded-lg bg-slate-900 text-white font-semibold">
              Get OTP
            </div>
            <p className="text-sm text-stone-500 text-center">
              By continuing, you agree to our{" "}
              <span className="underline underline-offset-4">
                Terms &amp; Conditions
              </span>
            </p>
          </div>

          <p className="text-sm text-stone-400 text-center max-w-90 mx-auto">
            Mutual Fund investments are subject to market risks. Read all scheme
            related documents carefully.
          </p>

          <div className="mt-auto self-end flex flex-col items-start gap-1 [&_svg]:text-slate-900">
            <span className="text-sm font-semibold text-stone-500">
              Powered by
            </span>
            <CresoTextLogo width={84} height={20} />
          </div>
        </div>
      </div>
    </div>
  );
}
